const CONDITIONS = [
  { key: 'dead',      emoji: '☠️', label: 'Mort' },
  { key: 'poisoned',  emoji: '🤢', label: 'Empoisonné' },
  { key: 'stunned',   emoji: '😵', label: 'Étourdi' },
  { key: 'burning',   emoji: '🔥', label: 'En feu' },
  { key: 'frozen',    emoji: '❄️', label: 'Gelé' },
  { key: 'asleep',    emoji: '😴', label: 'Endormi' },
  { key: 'wounded',   emoji: '🩹', label: 'Blessé' },
  { key: 'paralyzed', emoji: '⚡', label: 'Paralysé' },
  { key: 'protected', emoji: '🛡️', label: 'Protégé' },
  { key: 'cursed',    emoji: '👁️', label: 'Maudit' },
];

export default CONDITIONS;
